import { useMemo } from 'react';
import type { RouteName } from '@jira/platform__routing-route-name-types/src/RouteName.tsx';
import { useCurrentRoute } from '@jira/platform__utils-router/src/index.tsx';
import { useSidebarNav4 } from '@jira/navigation-apps__sidebar-nav4-context/src/controllers/sidebar-context/index.tsx';
import type { JiraConfigurableNavigationItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
/**
 * Routes where sidebar peek is disabled.
 * On these routes, the selected path is used for highlighting only, not for auto-expanding.
 */
const PEEK_DISABLED_ROUTES = new Set<RouteName>(['for-you']);

export function usePeekMenuId(navItems: JiraConfigurableNavigationItem[]): string | undefined {
	const { isSelectedPath } = useSidebarNav4();
	const currentRoute = useCurrentRoute();

	return useMemo(() => {
		if (PEEK_DISABLED_ROUTES.has(currentRoute.name)) {
			return undefined;
		}

		return navItems.find((item) => isSelectedPath(item.menuId))?.menuId;
	}, [navItems, isSelectedPath, currentRoute.name]);
}
